import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, Col } from 'react-bootstrap';
import { isEqual } from 'lodash';

import { StepBar } from '@components';

const stepArray = ['Personal Info', 'Billing Info'];

class NavBar extends Component {
	shouldComponentUpdate = ({ currentStep }) => {
		const lastProps = this.props;

		return (
			!isEqual(currentStep, lastProps.currentStep)
		);
	}

	render() {
		const { currentStep } = this.props;

		return (
			<Navbar
				fluid
				className="new-navbar new-navbar-square navbar-square col-md-12 padding-15"
			>
				<Col
					md={4}
					sm={4}
					xs={12}
					mdOffset={0}
					smOffset={0}
					xsOffset={2}
				>
					<Navbar.Header className="sign-up-navbar-header">
						<Navbar.Brand>
							<Link to="/">
								<img
									className="logo"
									src="/images/RKClient.png"
									alt="RK Client"
								/>
							</Link>
						</Navbar.Brand>
					</Navbar.Header>
				</Col>
				<Col
					md={4}
					sm={4}
					xs={12}
					className="signup-stepbar padding-top-10"
				>
					<StepBar
						currentStep={currentStep}
						stepArray={stepArray}
					/>
				</Col>
				<Col
					md={4}
					sm={4}
					xs={12}
					className="padding-top-10"
				>
					<div className="header-right">
						<span className="font-size-16 font-light">Already a member?</span>
						<Link
							to="/login"
							className="btn header-right-button"
						>
							Sign in
						</Link>
					</div>
				</Col>
			</Navbar>
		);
	}
}

const mapStateToProps = ({ signup : { currentStep } }) => ({
	currentStep,
});

NavBar.propTypes = {
	currentStep : PropTypes.number.isRequired,
};

export default connect(mapStateToProps)(NavBar);
